import { useQuery } from "react-query";
import { getReconciliationCount } from "actions/CarrierAgreementMgmt/VendorInvoice";

const useGetReconciliationCount = () => {
  return useQuery("GetReconciliationCount", getReconciliationCount, {
    refetchOnWindowFocus: false,
  });
};

export default useGetReconciliationCount;
